import i18n from "@/plugins/vue-i18n";

const DealerPromotions = () =>
  import(/* webpackChunkName: "dealer-promotions" */ "@/views/dealer-promotions/index");

const DealerPromotionDetails = () =>
  import(/* webpackChunkName: "dealer-promotions-details" */ "@/views/dealer-promotions/details");

const dealerPromotions = [
  {
    path: "/promotions",
    name: "DealerPromotions",
    component: DealerPromotions,
    meta: {
      title: i18n.t("title.dealerPromotions._"),
      permission: ["dealer_incentive.read_own", "dealer_incentive.read"],
    },
  },
  {
    path: "/promotions/:id",
    name: "DealerPromotionDetails",
    component: DealerPromotionDetails,
    meta: {
      title: i18n.t("title.dealerPromotions.details"),
      permission: ["dealer_incentive.read_own", "dealer_incentive.read"],
    },
  },
];

export default dealerPromotions;
